import React from 'react';
import { Typography } from 'lib/cortiUI';
export const CardSubheader = ({ text }) => {
    return React.createElement(Typography, null, text);
};
